const Pages = (props) => {
  return (
    <>
      <a href={props.link} target='_blank' rel='noreferrer'>
        <div className='rounded-md ring-1 ring-black p-3 m-4 flex iconpink gap-2 whitespace-nowrap md:hover:scale-110 transition'>
        
          <p>{props.title}</p>
        </div>
      </a>
    </>
  );
};

export default Pages;
